import { render } from "./Students.vue?vue&type=template&id=a2106980&scoped=true"
import script from "./Students.vue?vue&type=script&lang=js"
export * from "./Students.vue?vue&type=script&lang=js"

import "./Students.vue?vue&type=style&index=0&id=a2106980&scoped=true&lang=css"
import "./Students.vue?vue&type=style&index=1&id=a2106980&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2106980"]])

export default __exports__